import { render, staticRenderFns } from "./MyPermits.vue?vue&type=template&id=148eff53&"
import script from "./MyPermits.vue?vue&type=script&lang=ts&"
export * from "./MyPermits.vue?vue&type=script&lang=ts&"
import style0 from "./MyPermits.vue?vue&type=style&index=0&id=148eff53&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports